export const LOCALES = {
  "en": 'en-US',
  "de": 'de-DE',
  "km": 'km-KM'
};
